import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 7 7",
  "content": "<symbol viewBox=\"0 0 7 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\">\n<path d=\"M0 0.840896C0.012206 0.351865 0.42482 0.00984269 0.900744 0.000203232C1.05944 -0.00301135 1.2233 0.0318423 1.38329 0.109473L6.5304 2.77534C6.81043 2.92096 7 3.18829 7 3.50087C7 3.81344 6.81059 4.08078 6.5304 4.2264L1.38329 6.89227C0.743648 7.20267 0.0162285 6.80718 0 6.15531V0.840896Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol